/*
 * Carbisdale - SoundManager
 *
 * Verwaltet Audio-Feedback für blockierte Aktionen.
 * Wählt den Sound je nach Display Mode (Nerd vs. andere).
 */

import { DisplayMode } from './config.js'

export class SoundManager {
    /**
     * @param {Function} getDisplayMode - Callback das den aktuellen Display Mode zurückgibt
     */
    constructor(getDisplayMode) {
        this._getDisplayMode = getDisplayMode

        // Sounds vorladen
        this._nerdSound = new Audio('sounds/alert_nerd.mp3')
        this._normalSound = new Audio('sounds/alert.mp3')

        // Diktat-Sounds vorladen
        this._dictStartSound = new Audio('sounds/dictation_start.mp3')
        this._dictStartNerdSound = new Audio('sounds/dictation_start_nerd.mp3')
        this._dictStopSound = new Audio('sounds/dictation_stop.mp3')
        this._dictStopNerdSound = new Audio('sounds/dictation_stop_nerd.mp3')

        // AI-Sounds vorladen (einheitlich fuer alle Modi)
        this._aiReadySound = new Audio('sounds/ai_ready.mp3')
        this._aiReadySound.volume = 0.4
        this._aiAbortedSound = new Audio('sounds/ai_aborted.mp3')
        this._aiAbortedSound.volume = 0.4

        // Rapid-Fire-Schutz: maximal ein Ping pro 100ms
        this._lastPlayTime = 0
        this._minInterval = 100
    }

    /**
     * Spielt den Ping-Alarm-Sound.
     * Nerd-Mode bekommt den speziellen Nerd-Sound, alle anderen den normalen.
     */
    playPing() {
        this._play(this._normalSound, this._nerdSound)
    }

    /**
     * Spielt den Diktat-Start-Sound.
     */
    playDictationStart() {
        this._play(this._dictStartSound, this._dictStartNerdSound)
    }

    /**
     * Spielt den Diktat-Stopp-Sound.
     */
    playDictationStop() {
        this._play(this._dictStopSound, this._dictStopNerdSound)
    }

    /**
     * Spielt den AI-Ready-Sound (wenn eine Agent-Antwort fertig ist).
     * Einheitlich fuer alle Display Modes.
     */
    playAIReady() {
        this._playSingle(this._aiReadySound)
    }

    /**
     * Spielt den AI-Abort-Sound (wenn der Agent-Loop abgebrochen wurde).
     * Einheitlich fuer alle Display Modes.
     */
    playAIAborted() {
        this._playSingle(this._aiAbortedSound)
    }

    /**
     * Interne Abspielfunktion mit Rapid-Fire-Schutz und Nerd-Mode-Erkennung.
     * @param {HTMLAudioElement} normalSound
     * @param {HTMLAudioElement} nerdSound
     */
    _play(normalSound, nerdSound) {
        const now = Date.now()
        if (now - this._lastPlayTime < this._minInterval) return
        this._lastPlayTime = now

        const mode = this._getDisplayMode()
        const isNerd = mode === DisplayMode.ULTRA_NERD || mode === DisplayMode.REGULAR_NERD
        const sound = isNerd ? nerdSound : normalSound

        // Zurückspulen falls noch laufend, dann abspielen
        sound.currentTime = 0
        sound.play().catch(() => {})
    }

    /**
     * Spielt einen einzelnen Sound (ohne Nerd-Variante) mit Rapid-Fire-Schutz.
     * @param {HTMLAudioElement} sound
     */
    _playSingle(sound) {
        const now = Date.now()
        if (now - this._lastPlayTime < this._minInterval) return
        this._lastPlayTime = now

        sound.currentTime = 0
        sound.play().catch(() => {})
    }
}
